import { logger } from "@usap/core";
import getCookieRegex from '../helpers/getCookieRegex'

const encodeHeaderValue = (jsonObject: Record<string, any>): string => {
    try {
        return encodeURIComponent(JSON.stringify(jsonObject));
    } catch (error) {
        return "";
    }
};

const getXCtrValueString = () => {
    try {
        const encodedXCTRValue = encodeHeaderValue({
            ConstructorioID_client_id: getCookieRegex("ConstructorioID_client_id") || null,
            ConstructorioID_session_id: getCookieRegex("ConstructorioID_session_id") || null,
            userId: getCookieRegex("userId") || null,
        });

        return encodedXCTRValue;
    } catch (error) {
        logger.error("error encoding x-ctr-value", error);
        return encodeHeaderValue({
            ConstructorioID_client_id: null,
            ConstructorioID_session_id: null,
        });
    }
};

export default getXCtrValueString